export class ReportRequest {
  // variables

  dateEnd: Date;
  dateStart: Date;
}
